// extracted by mini-css-extract-plugin
export var blockNftStaked = "BlockNftStaked_blockNftStaked__sRs3R";